export const defaultCss = `
    --main-top-bg-color: #164e99;
    --main-top-text-color: #ffffff;
    `;
